import Container from '@/components/global/Container';
import Grid from '@/components/global/Grid';
import { TitleAndDescription } from '@/components/shared/TitleAndDescription';
import { ICardEntity, IComponentBlocksCardsBlock } from '@/graphql/__generated__/global/types';
import { determineCardSizesByCardSpan } from '@/helpers/determineCardSizesByCardSpan';
import { determineCardSpan } from '@/helpers/determineCardSpan';
import { useMediaQuery } from '@/hooks/useMediaQuery';
import dynamic from 'next/dynamic';

const Card = dynamic(() => import('@/components/elements/Card/CardRenderer'));

const CardsBlock = ({ titleDescription, card_collections }: IComponentBlocksCardsBlock) => {
    const isTabletOrLarger = useMediaQuery('md');

    const { data } = card_collections || { data: [] };

    return (
        <Container className="grid gap-10 xl:gap-16">
            {titleDescription && <TitleAndDescription {...titleDescription} />}
            {data.map((collection, id) => {
                if (collection.attributes) {
                    return (
                        <Grid key={`${collection?.id}${id}`}>
                            {collection.attributes.cards?.data?.map((card, index) => {
                                const { image, eyebrowText, title, description, link, backgroundColour, video, tintImage } = card.attributes?.Card ?? {};

                                const cardSpan = determineCardSpan(collection.attributes?.cards?.data as ICardEntity[], card as ICardEntity, undefined, true);

                                const cardSizes = determineCardSizesByCardSpan(cardSpan);

                                const shouldReverseOrder = collection.attributes && collection.attributes.reverseOrderOnMobile && !isTabletOrLarger;

                                const cardOrder = shouldReverseOrder && collection?.attributes?.cards?.data ? `${collection.attributes.cards.data.length - index}` : 'initial';
                                return (
                                    <Card
                                        key={index}
                                        card={{
                                            image,
                                            eyebrowText,
                                            title,
                                            description,
                                            link,
                                            backgroundColour,
                                            video,
                                            tintImage,
                                            sizes: cardSizes,
                                            order: cardOrder,
                                        }}
                                        span={cardSpan}
                                    />
                                );
                            })}
                        </Grid>
                    );
                }
            })}
        </Container>
    );
};

export default CardsBlock;
